import { Outlet } from 'react-router-dom';
import { ClientsProvider } from 'components/Clients/context/ClientsProvider';

const ClientWrapper = () => {
    return (
        <ClientsProvider>
            <Outlet />
        </ClientsProvider>
    );
};

export default ClientWrapper;
